import { CustomersGridView } from '~/components/customers/list/customers-grid';
import { PageContainer } from '~/components/page-container';

export function CustomersList() {
	return (
		<PageContainer>
			<CustomersGridView />
		</PageContainer>
	);
}
